export enum CardType {
  NORMALWITHOUTSIZE = 'NORMALWITHOUTSIZE',
  NORMAL = 'NORMAL',
  DROPDOWN = 'DROPDOWN',
  QTYSTEPPER = 'QTYSTEPPER',
  FREEPRODUCT = 'FREEPRODUCT',
  PLPHEADER = 'PLPHEADER',
  CHECKOUT = 'CHECKOUT',
  PRODUCTMERCHANDISE = 'PRODUCTMERCHANDISE',
  PROMOTIONCARD = 'PROMOTIONCARD',
  PDPHEADERTYPE = 'PDPHEADERTYPE',
  GCOCARD = 'GCOCARD',
  CART_CARD = 'CART_CARD',
  APOINT_REDEEM_CARD = 'APOINT_REDEEM_CARD',
  BUNDLE_CARD = 'BUNDLE_CARD',
}
